var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.getActive)?_c('div',{staticClass:"notification",class:_vm.styles,attrs:{"role":"alert","aria-live":"polite","aria-atomic":"true"}},[_vm._v(" "+_vm._s(_vm.getText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }